module.exports = __webpack_public_path__ + "media/newstyle/images/70-mil-authors-05c48395f822e5def588670424db77c5.svg";